// Claves de localStorage para preferencias de notificaciones del usuario.
export const NOTIFY_PREF_KEYS = {
  notifyPending: "venttify_notify_pending",
  onlyAssigned: "venttify_only_assigned",
};

// Lee una preferencia booleana desde localStorage.
// Si no existe o hay error de parseo, devuelve defaultValue.
export const getNotifyPref = (key, defaultValue = false) => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null || raw === undefined) return defaultValue;
    return raw === "true";
  } catch (err) {
    return defaultValue;
  }
};

// Persiste una preferencia booleana en localStorage.
export const setNotifyPref = (key, value) => {
  try {
    localStorage.setItem(key, value ? "true" : "false");
  } catch (err) {
    console.warn("No se pudo guardar la preferencia de notificación:", err);
  }
};
